import React, { useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { apiHandler } from '../../../api/apihandler';
import { FEED_MADE_IT_LIST } from '../../../api/constants';
import { apiSucceeded } from '../../../views/dashboard/feed/feedUtils';
import { MadeItEntryScreen, MadeItListScreen, MadeItRecipeScreen } from './home-app-page';
import RelatedRecipesWidget from '../../../components/nemonto/RelatedRecipesWidget';
import './home-app-page.css';

// Dedicated, URL-routed recipe detail screen (/pages/recipe/:id) - reuses
// the same themed recipe view (ingredients/steps/tips/cook time/etc.) built
// for the live feed's internal "open recipe" flow, so recipes opened from
// outside the feed (e.g. My Profile's recipe grid) land on a real,
// bookmarkable/shareable screen instead of the old generic post page.
const RecipeDetailPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [flow, setFlow] = useState('recipe');
  const [detail, setDetail] = useState(null);
  const [madeItEntries, setMadeItEntries] = useState([]);
  const [madeItLoading, setMadeItLoading] = useState(false);

  // Stable reference (not recreated every render) - MadeItRecipeScreen's
  // data-fetch effect keys off this object, so a fresh literal here would
  // re-trigger that effect every time onDetailLoaded fires below, causing
  // a refetch loop that stomps on optimistic like/save UI updates.
  const post = useMemo(() => ({ id, originalId: id }), [id]);

  async function openMadeItList() {
    setMadeItEntries([]);
    setMadeItLoading(true);
    try {
      const res = await apiHandler(FEED_MADE_IT_LIST, 'POST', { page: 1, limit: 10, original_recipe_id: id });
      if (apiSucceeded(res)) setMadeItEntries(res?.data?.data?.data || []);
    } catch (e) {
      console.error(e);
    } finally {
      setMadeItLoading(false);
    }
  }

  return (
    <div className="nmha-root">
      <div className="nmha-app">
        <main className="nmha-feed-col">
          {flow === 'entry' ? (
            <MadeItEntryScreen post={{ ...post, title: detail?.title }} onClose={() => setFlow('recipe')} />
          ) : flow === 'list' ? (
            <MadeItListScreen
              post={{ title: detail?.title, madeItCount: detail?.made_it_count }}
              entries={madeItEntries}
              loading={madeItLoading}
              onBackHome={() => setFlow('recipe')}
            />
          ) : (
            <MadeItRecipeScreen
              post={post}
              onBackHome={() => navigate(-1)}
              onMadeItPress={() => setFlow('entry')}
              onMadeItCountPress={() => { setFlow('list'); openMadeItList(); }}
              onLikeChange={() => {}}
              onFavoriteChange={() => {}}
              onDetailLoaded={setDetail}
            />
          )}
        </main>

        <aside className="nmha-right-rail">
          <RelatedRecipesWidget currentId={id} />
        </aside>
      </div>
    </div>
  );
};

export default RecipeDetailPage;
